import { render } from "./DeleteShelterDialog.vue?vue&type=template&id=27cc6450&scoped=true"
import script from "./DeleteShelterDialog.vue?vue&type=script&lang=js"
export * from "./DeleteShelterDialog.vue?vue&type=script&lang=js"

import "./DeleteShelterDialog.vue?vue&type=style&index=0&id=27cc6450&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cc6450"]])

export default __exports__